import { reactive } from 'vue';

export const store = reactive({
  url: '',
  loading: false,
  finished: false
});
